import { useState } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import Header from './Header';
import SideNav from './SideNav';

const drawerWidth = 240;

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));

const MainLayout = ({ children, themeMode, toggleTheme }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [open, setOpen] = useState(!isMobile);

  const toggleDrawer = () => {
    setOpen(!open);
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <Header 
        themeMode={themeMode} 
        toggleTheme={toggleTheme} 
        open={open}
        toggleDrawer={toggleDrawer}
        drawerWidth={drawerWidth}
        isMobile={isMobile}
      />
      <SideNav 
        open={open}
        toggleDrawer={toggleDrawer}
        drawerWidth={drawerWidth}
        isMobile={isMobile}
      />
      <Box 
        component="main" 
        sx={{ 
          flexGrow: 1, 
          p: { xs: 2, sm: 3 },
          width: { xs: '100%', md: `calc(100% - ${open ? drawerWidth : 65}px)` }
        }}
      >
        <DrawerHeader />
        {children}
      </Box>
    </Box>
  );
};

export default MainLayout;
